/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ total: NonNullable<unknown>, count: NonNullable<unknown> }} Search_Foot_ResultsInputs */

const en_search_foot_results = /** @type {(inputs: Search_Foot_ResultsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total} matched · ${i?.count} endpoints`)
};

const zh_hans1_search_foot_results = /** @type {(inputs: Search_Foot_ResultsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`匹配 ${i?.total} 个 · 共 ${i?.count} 个接口`)
};

const pt_br2_search_foot_results = /** @type {(inputs: Search_Foot_ResultsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total} encontrados · ${i?.count} endpoints`)
};

const es_search_foot_results = /** @type {(inputs: Search_Foot_ResultsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total} coincidencias · ${i?.count} endpoints`)
};

const fr_search_foot_results = /** @type {(inputs: Search_Foot_ResultsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total} correspondances · ${i?.count} endpoints`)
};

const de_search_foot_results = /** @type {(inputs: Search_Foot_ResultsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total} Treffer · ${i?.count} Endpoints`)
};

const ru_search_foot_results = /** @type {(inputs: Search_Foot_ResultsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Найдено ${i?.total} · эндпоинтов: ${i?.count}`)
};

const it_search_foot_results = /** @type {(inputs: Search_Foot_ResultsInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.total} corrispondenze · ${i?.count} endpoint`)
};

/**
* | output |
* | --- |
* | "{total} matched · {count} endpoints" |
*
* @param {Search_Foot_ResultsInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const search_foot_results = /** @type {((inputs: Search_Foot_ResultsInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Foot_ResultsInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_search_foot_results(inputs)
	if (locale === "pt-BR") return pt_br2_search_foot_results(inputs)
	if (locale === "es") return es_search_foot_results(inputs)
	if (locale === "fr") return fr_search_foot_results(inputs)
	if (locale === "de") return de_search_foot_results(inputs)
	if (locale === "ru") return ru_search_foot_results(inputs)
	if (locale === "it") return it_search_foot_results(inputs)
	return en_search_foot_results(inputs)
});